<script setup>

//get query param
const urlParams = new URLSearchParams(window.location.search);
const state = urlParams.get('state');

</script>

<template>
  <div class="container onboarding-result">
    <template v-if="state === 'Complete'">
      <div class="status-icon status-icon--complete"></div>
    </template>
    <template v-else>
      <div class="status-icon status-icon--failed"></div>
    </template>
  </div>
</template>
<style scoped lang="scss">
.onboarding-result {
    padding-top: calc(50vh - 100px);
}
.status-icon {
    display: block;
    margin: 0 auto;
    height: 200px;
    width: 200px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;

    &--complete {
        background-image: url(../assets/img/icon-complete.png);
    }

    &--failed {
        background-image: url(../assets/img/icon-failed.png);
    }
}


</style>